import React, { createContext, useContext, useState, ReactNode } from 'react';

// 1. Define the shape of the context value
interface HeaderFilterContextType {
  filters: ReactNode | null;
  setFilters: (filters: ReactNode | null) => void;
}

// 2. Create the context
const HeaderFilterContext = createContext<HeaderFilterContextType | undefined>(undefined);

// 3. Define the props for the provider component
interface HeaderFilterProviderProps {
  children: ReactNode;
}

// 4. Implement the provider
export const HeaderFilterProvider: React.FC<HeaderFilterProviderProps> = ({ children }) => {
  const [filters, setFilters] = useState<ReactNode | null>(null);

  return (
    <HeaderFilterContext.Provider value={{ filters, setFilters }}>
      {children}
    </HeaderFilterContext.Provider>
  );
};

// 5. Custom hook to use the context 
export const useHeaderFilters = (): HeaderFilterContextType => {
  const context = useContext(HeaderFilterContext);
  if (!context) {
    throw new Error('useHeaderFilters must be used within a HeaderFilterProvider');
  }
  return context;
};

